import { Navigate, useMatch, useParams } from 'react-router';
import { Typography } from 'react-md';
import { ROUTES } from '@constants/routes';
import { StartPageLocation } from './start-page-location';
import { StartPageTile } from './start-page-tile';
import {
    TTI_SELECT_REGION_TILES,
    TTI_SELECT_LOCATION_TILES,
    TTI_SELECT_REGION_INFO,
    TTI_SELECT_LOCATION_INFO,
    TTI_REGIONS,
} from './const';

import styles from './tti-start-page.module.scss';

//----- This page is made specifically for TTI company -----//

export function TtiStartPage() {
    const { region } = useParams();
    const isLegacy = Boolean(useMatch(ROUTES.ttiLegacyPage));

    if (region && !TTI_REGIONS.includes(region)) return <Navigate to={ROUTES.notFound} />;

    let { title, description } = region ? TTI_SELECT_LOCATION_INFO : TTI_SELECT_REGION_INFO;
    let tiles = region ? TTI_SELECT_LOCATION_TILES[region] : TTI_SELECT_REGION_TILES;

    //TODO: 3664 Remove this code for legacy page support when it isn't needed any more
    if (isLegacy) {
        tiles = TTI_SELECT_LOCATION_TILES['us'].filter(tile => tile.title !== 'Tufting');
        title = TTI_SELECT_LOCATION_INFO.title;
        description = TTI_SELECT_LOCATION_INFO.description;
    }

    return (
        <div className={styles['layout']}>
            <div className={styles['header']}>
                <img
                    className={styles['logo']}
                    src="https://app.digifabster.com/img/start-page/tti/logo.png"
                    alt="logo"
                />
            </div>
            <div className={styles['content-container-layout']}>
                <div className={styles['content-container']}>
                    <div className={styles['info-container']}>
                        <div className={styles['title-container']}>
                            <h1>{title}</h1>
                            <StartPageLocation region={region} />
                        </div>
                        {description && <Typography>{description}</Typography>}
                    </div>
                    <div className={styles['tiles-container']}>{tiles.map(tile => StartPageTile(tile))}</div>
                </div>
            </div>
        </div>
    );
}
